"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = require("react");
function useItemList(onCompare, onFilter) {
    var _a = (0, react_1.useState)([]), items = _a[0], setItems = _a[1];
    var _b = (0, react_1.useState)(''), filter = _b[0], setFilter = _b[1];
    var get = (0, react_1.useCallback)(function () { return Array.from(items.filter(function (item) { return onFilter ? onFilter(filter, item) : true; })); }, [items, filter]);
    var update = (0, react_1.useCallback)(function () {
        var items = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            items[_i] = arguments[_i];
        }
        var newItems = get();
        items.forEach(function (item) {
            var index = newItems.findIndex(function (iterItem) {
                return onCompare(iterItem, item);
            });
            if (index >= 0)
                newItems[index] = item;
            else
                newItems.push(item);
        });
        setItems(newItems);
        return newItems;
    }, [items]);
    var deleteItem = (0, react_1.useCallback)(function () {
        var items = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            items[_i] = arguments[_i];
        }
        var newItems = get();
        items.forEach(function (item) {
            var index = newItems.findIndex(function (iterItem) {
                return onCompare(iterItem, item);
            });
            if (index >= 0)
                newItems.splice(index, 1);
        });
        setItems(newItems);
        return newItems;
    }, [items]);
    var length = (0, react_1.useCallback)(function () { return items.length; }, [items]);
    var moveIndex = (0, react_1.useCallback)(function (from, to) {
        var newItems = get();
        var item = newItems[from];
        newItems.splice(from, 1);
        newItems.splice(to, 0, item);
        setItems(newItems);
        return newItems;
    }, [items]);
    var move = (0, react_1.useCallback)(function (from, to) {
        var fromIndex = items.findIndex(function (item) { return onCompare(item, from); });
        var toIndex = items.findIndex(function (item) { return onCompare(item, to); });
        if (fromIndex >= 0 && toIndex >= 0)
            return moveIndex(fromIndex, toIndex);
        return get();
    }, [items]);
    var clear = function () { return setItems([]); };
    return {
        get: get,
        update: update,
        delete: deleteItem,
        length: length,
        moveIndex: moveIndex,
        move: move,
        clear: clear,
        setFilter: setFilter
    };
}
exports.default = useItemList;
